import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppLayout } from './components/AppLayout';
import { ProductScopeLayout } from './components/ProductScopeLayout';
import { RoleRoute } from './components/RoleRoute';
import { GuestRoute, ProtectedRoute } from './components/ProtectedRoute';
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import { useOperatorPermissions } from './hooks/useOperatorPermissions';
import { AgentDetailPage } from './pages/AgentDetailPage';
import { AgentsPage } from './pages/AgentsPage';
import { DashboardPage } from './pages/DashboardPage';
import { InstagramPage } from './pages/InstagramPage';
import { ModelsPage } from './pages/ModelsPage';
import { LoginPage } from './pages/LoginPage';
import { PlansPage } from './pages/PlansPage';
import { TelegramBusinessPage } from './pages/TelegramBusinessPage';
import { UsageAnalyticsPage } from './pages/UsageAnalyticsPage';
import { UserDetailPage } from './pages/UserDetailPage';
import { UsersPage } from './pages/UsersPage';
import { EconomicsPage } from './pages/EconomicsPage';

function AppRoutes() {
  const perms = useOperatorPermissions();
  const appPath = (subpath = '') => `/app${subpath ? `/${subpath}` : ''}`;

  return (
    <Routes>
      <Route
        path="/login"
        element={
          <GuestRoute>
            <LoginPage />
          </GuestRoute>
        }
      />
      <Route
        element={
          <ProtectedRoute>
            <AppLayout product="app" />
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/app" replace />} />
        <Route path="app" element={<ProductScopeLayout scope="app" />}>
          <Route index element={<DashboardPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="users/:id" element={<UserDetailPage />} />
          <Route path="agents" element={<AgentsPage />} />
          <Route path="agents/:id" element={<AgentDetailPage />} />
          <Route path="plans" element={<PlansPage />} />
          <Route
            path="economics"
            element={
              <RoleRoute allowed={perms.canViewBilling}>
                <EconomicsPage product="APP" />
              </RoleRoute>
            }
          />
          <Route
            path="models"
            element={
              <RoleRoute allowed={perms.canViewModels}>
                <ModelsPage product="app" />
              </RoleRoute>
            }
          />
          <Route
            path="usage"
            element={
              <RoleRoute allowed={perms.canViewUsage}>
                <UsageAnalyticsPage />
              </RoleRoute>
            }
          />
          <Route
            path="instagram"
            element={
              <RoleRoute allowed={perms.canViewInstagram}>
                <InstagramPage />
              </RoleRoute>
            }
          />
          <Route
            path="telegram-business"
            element={
              <RoleRoute allowed={perms.canViewTelegramBusiness}>
                <TelegramBusinessPage />
              </RoleRoute>
            }
          />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to={appPath()} replace />} />
    </Routes>
  );
}

export default function AppApp() {
  return (
    <AuthProvider>
      <ToastProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </ToastProvider>
    </AuthProvider>
  );
}
